import tabsMenuHandler from "./components/tabsMenuHandler.js";
import showMoreOffer from "./components/showMoreOffer.js";
import tabsOfferHandler from "./components/tabsOfferHandler.js";
import searchHandler from "./components/searchHandler.js";
import mobmenuHandler from "./components/mobmenuHandler.js";
import backToTopHandler from "./components/backToTopHandler.js";
import showMoreOffersHandler from "./components/showMoreOffersHandler.js";
import faqToggle from "./components/faqHandler.js";


document.addEventListener("DOMContentLoaded", () => {

    'use strict';

    tabsMenuHandler(document, ".tabs__tab", ".tabs-accordion__title", ".tabs-accordion__content");
    tabsOfferHandler();
    showMoreOffer();
    searchHandler();
    mobmenuHandler('.menu-mob', '.menu-primary' );
    backToTopHandler();
    showMoreOffersHandler();
    faqToggle();
});